/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisplayedProfile
 */
export interface DisplayedProfile {
    /**
     * 
     * @type {string}
     * @memberof DisplayedProfile
     */
    profileId: string;
    /**
     * The zero-based position of the result in the selection page.
     * @type {number}
     * @memberof DisplayedProfile
     */
    position?: number;
}

/**
 * Check if a given object implements the DisplayedProfile interface.
 */
export function instanceOfDisplayedProfile(value: object): value is DisplayedProfile {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    return true;
}

export function DisplayedProfileFromJSON(json: any): DisplayedProfile {
    return DisplayedProfileFromJSONTyped(json, false);
}

export function DisplayedProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayedProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function DisplayedProfileToJSON(value?: DisplayedProfile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'position': value['position'],
    };
}

